import WIDGETS from './widgets';

export default {
  name: 'dashboard',
	widgets: [
		{ content: WIDGETS.DASHBOARD, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
	],
};
